import { Box, Skeleton } from "@mui/material";

export function ProfileSkeleton() {
  return (
    <Box
      sx={{ display: "flex", gap: 2, alignItems: "flex-start", width: "100%" }}
    >
      <Skeleton
        variant="circular"
        width={35}
        height={35}
        sx={{ flexShrink: 0 }}
      />
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1 }}>
        <Skeleton variant="rectangular" height={25} sx={{ borderRadius: '4px' }} />
        <Skeleton variant="rectangular" height={25} sx={{ borderRadius: '4px' }} />
        <Skeleton variant="rectangular" height={90} sx={{ borderRadius: '4px' }} />
      </Box>
    </Box>
  );
}
